import { jsx as _jsx } from "react/jsx-runtime";
import noop from 'lodash/fp/noop';
import Button from '../button/Button';
const SidebarCloseButton = ({ onClick = noop }) => {
    return (_jsx(Button, { bsStyle: Button.MUTED, iconOnly: true, onClick: onClick, "data-testid": 'sidebarCloseButton', children: _jsx("span", { className: 'rioglyph rioglyph-remove' }) }));
};
export default SidebarCloseButton;
